import { useState } from "react";
import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber, convertPayloadToFormData } from "../../shared/utility";

export function VisitorLogViewModel(logout, id, addSnackbar) {
  const [inProgress, setInProgress] = useState(false);
  const [visitorTypeOptions, setVisitorTypeOptions] = useState([]);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [visitor, setVisitor] = useState(null);
  const [loading, setLoading] = useState(false);

  const getVisitorTypesForDropdown = async function () {
    let callResult = await makePostApiCall(`visitorTypesForDropdown`, {});
    if (callResult.success) {
      setVisitorTypeOptions(callResult.data || []);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showErrorModal(
          callResult.data?.message || "Could not load visitor types"
        );
      }
    }
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getVisitorDetails = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall(`visitorLogs/${id}`, {});

    if (callResult.success) {
      setVisitor(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showErrorModal(callResult.data?.message || "Could not load visitor");
      }
    }
    setLoading(false);
  };

  const checkoutVisitor = async function () {
    setInProgress(true);

    let callResult = await makePostApiCall(
      `visitor/checkout-visitor/${id}`,
      {}
    );

    if (callResult.success) {
      let message = "Visitor checked out successfully";
      addSnackbar(
        new SnackbarData(generateUniqueNumber(), message, SnackbarType.Success)
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data?.message || "Could not checkout visitor");
    }
    setInProgress(false);
    return callResult;
  };

  const createVisitor = async function (values) {
    const formData = convertPayloadToFormData(values);
    const user_id = localStorage.getItem("id") * 1;
    formData.append("user_id", user_id);
    let callResult = await makePostApiCall(
      "/visitorLogs/create",
      formData,
      "multipart/form-data"
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const updateVisitor = async function (values) {
    const formData = convertPayloadToFormData(values);
    const user_id = localStorage.getItem("id") * 1;
    formData.append("user_id", user_id);
    let callResult = await makePostApiCall(
      `visitorLogs/${id}/update`,
      formData,
      "multipart/form-data"
    );
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  return {
    inProgress,
    createVisitor,
    visitorTypeOptions,
    getVisitorTypesForDropdown,
    emptyModal,
    setEmptyModelOpen,
    loading,
    visitor,
    getVisitorDetails,
    updateVisitor,
    checkoutVisitor,
  };
}

export default VisitorLogViewModel;
